import HeaderContainer from './HeaderContainer';
import HeaderUI from './HeaderUI';
import headerReducer from './headerReducer';

const Header = {
    Container: HeaderContainer,
    UI: HeaderUI,
    reducer: headerReducer
};

export default Header;
